import React from 'react';
import imgae1 from '../img/about-1.jpg'
import imgae2 from '../img/about-2.jpg'
import { CONTACT_FORM_URL, GOOGLE_FORM_URL } from './AppConstant';

const About = () => {
  return (
    <div className="container-fluid py-5 my-5">
      <div className="container pt-5">
        <div className="row g-5">
          {/* Left Image Section */}
          <div className="col-lg-5 col-md-6 col-sm-12 wow fadeIn" data-wow-delay=".3s">
            <div className="h-100 position-relative">
              <img
                src={imgae1}
                className="img-fluid w-75 rounded"
                alt="About Aesos"
                style={{ marginBottom: '25%' }}
              />
              <div
                className="position-absolute w-75"
                style={{ top: '25%', left: '25%' }}
              >
                <img
                  src={imgae2}
                  className="img-fluid w-100 rounded"
                  alt="Aesos Innovation"
                />
              </div>
            </div>
          </div>

          {/* Text Content Section */}
          <div className="col-lg-7 col-md-6 col-sm-12 wow fadeIn" data-wow-delay=".5s">
            <h5 className="text-primary">About Us</h5>
            <h1 className="mb-4">About Aesos Agency and Its Innovative IT Solutions</h1>
            <p>
              Aesos is a forward-thinking IT agency dedicated to delivering smart, scalable,
              and result-driven digital solutions. With a strong focus on innovation and quality,
              we help businesses streamline their operations, boost productivity, and stay competitive
              in the digital era.
            </p>
            <p className="mb-4">
              Our services span custom software development, cloud solutions, cybersecurity,
              and IT consulting. Additionally, we empower individuals and organizations through
              practical, industry-aligned training programs in areas like data science, AI, and
              full-stack development.
            </p>
            <a href={CONTACT_FORM_URL} className="btn btn-secondary rounded-pill px-5 py-3 text-white">
              Contact
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
